/**
 * Adds a specified number of business days (Mon-Fri) to a Luxon DateTime object.
 * @param date The starting Luxon DateTime object.
 * @param days The number of business days to add.
 * @returns A new Luxon DateTime object.
 */
export const addBusinessDays = (date, days) => {
    if (!date.isValid) {
        return date;
    }
    let businessDaysAdded = 0;
    let newDate = date;
    while (businessDaysAdded < days) {
        newDate = newDate.plus({ days: 1 });
        if (newDate.weekday < 6) {
            businessDaysAdded++;
        }
    }
    return newDate;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGF0ZVV0aWxzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL2RhdGVVdGlscy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQTs7Ozs7R0FLRztBQUNILE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FBRyxDQUFDLElBQWMsRUFBRSxJQUFZLEVBQVksRUFBRTtJQUN4RSxJQUFJLENBQUMsSUFBSSxDQUFDLE9BQU8sRUFBRSxDQUFDO1FBQ2xCLE9BQU8sSUFBSSxDQUFDO0lBQ2QsQ0FBQztJQUNELElBQUksaUJBQWlCLEdBQUcsQ0FBQyxDQUFDO0lBQzFCLElBQUksT0FBTyxHQUFHLElBQUksQ0FBQztJQUNuQixPQUFPLGlCQUFpQixHQUFHLElBQUksRUFBRSxDQUFDO1FBQ2hDLE9BQU8sR0FBRyxPQUFPLENBQUMsSUFBSSxDQUFDLEVBQUUsSUFBSSxFQUFFLENBQUMsRUFBRSxDQUFDLENBQUM7UUFDcEMsSUFBSSxPQUFPLENBQUMsT0FBTyxHQUFHLENBQUMsRUFBRSxDQUFDO1lBQ3hCLGlCQUFpQixFQUFFLENBQUM7UUFDdEIsQ0FBQztJQUNILENBQUM7SUFDRCxPQUFPLE9BQU8sQ0FBQztBQUNqQixDQUFDLENBQUMifQ==